import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=d6a126b8&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=ts&"
export * from "./cooperation.vue?vue&type=script&lang=ts&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=d6a126b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a126b8",
  null
  
)

export default component.exports